module.exports = __webpack_public_path__ + "img/leiterinnen_tanja-furrer.64b49c1f.png";